"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
var chevronLeft = require('../../assets/blackLeftChevron.png');
var chevronRight = require('../../assets/blackRightChevron.png');
function Swiper({ data, pagingEnabled, renderItem, keyExtractor, itemWidth, showArrows = true }) {
    const swiperRef = react_1.useRef(null);
    const [currentIndex, setCurrentIndex] = react_1.useState(0);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        showArrows && (react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                let offset = -(itemWidth * (currentIndex - 1));
                if (currentIndex === 0 && data) {
                    offset = -(itemWidth * data.length - 1);
                }
                swiperRef.current && swiperRef.current.scrollToOffset({ offset });
            } },
            react_1.default.createElement(react_native_1.Image, { resizeMode: "contain", source: chevronRight, style: styles.chevron }))),
        react_1.default.createElement(react_native_1.FlatList, { ref: swiperRef, onScroll: (event) => {
                const currentIndi = Math.abs(Math.round(event.nativeEvent.contentOffset.x / itemWidth));
                setCurrentIndex(currentIndi);
            }, showsHorizontalScrollIndicator: false, pagingEnabled: pagingEnabled, keyExtractor: keyExtractor, renderItem: renderItem, data: data, horizontal: true }),
        showArrows && (react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                let offset = -(itemWidth * (currentIndex + 1));
                if (data && currentIndex === data.length - 1) {
                    offset = 0;
                }
                swiperRef.current && swiperRef.current.scrollToOffset({ offset });
            } },
            react_1.default.createElement(react_native_1.Image, { resizeMode: "contain", source: chevronLeft, style: styles.chevron })))));
}
exports.default = Swiper;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    chevron: {
        height: 60,
        width: 60,
    },
});
